// extracted by mini-css-extract-plugin
export default {"wrapper":"PopupPortalOverlay_wrapper__+HJcr"};